import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Link } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  description: {
    paddingTop: '2vh',
    fontSize: '16px',
    color: '#4e4e4e',
    textAlign: 'center',
    marginRight: '7vw',
    marginLeft: '7vw'
  },
  title: {
    fontWeight: 700,
    textAlign: 'center',
    fontSize: 32,
    marginTop: '8vh',
    lineHeight: 'normal'
  },
  repository: {
    textAlign: 'center',
    fontSize: 20,
    marginTop: '8vh',
    color: '#b15858'
  },
  url: {
    textAlign: 'center',
    fontSize: 20,
    marginTop: '1vh'
  }
}));

const Header = props => {
  const { className, ...rest } = props;
  const classes = useStyles();
  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        container
        justify="center"
        style={{ marginTop: '-1%' }}
      >
        <Grid item>
          <Typography className={classes.title}>Neighborhood Composition Strategies in Stochastic Local Search</Typography>
          <Typography className={classes.description} >10th International Workshop on Hybrid Metaheuristics</Typography>
          <Typography className={classes.description} >Plymouth, United Kingdom, June 8-10, 2016</Typography>
          <Typography className={classes.description} ><b>ABSTRACT: </b>Methods based on Stochastic Local Search (SLS) have been ranked as the best heuristics available for many hard combinatorial optimization problems. The design of SLS methods which use many neighborhoods poses difficult questions regarding the exploration of these neighborhoods: how much computational effort should be invested in each neighborhood? Should this effort remain fixed during the entire search or should it be dynamically updated as the search progresses? Additionally, is it possible to learn the best configurations during runtime without sacrificing too much the computational efficiency of the search method? In this paper we explore different tuning strategies to configure a state-of-the-art algorithm employing fourteen neighborhoods for the Multi-Mode Resource Constrained Multi-Project Scheduling Problem. An extensive set of computational experiments provide interesting insights for neighborhood selection and improved upper bounds for many hard instances from the literature.</Typography>
          <Typography className={classes.description} ><b>ISSN: </b>0302-9743</Typography>
          <Typography className={classes.description} ><b>PAGES: </b>118-130</Typography>

          <Typography className={classes.repository}>Link 1</Typography>
          <Typography className={classes.url}>
            <Link
              component="a"
              href="https://www.researchgate.net/publication/303512212_Hybrid_Metaheuristics_10th_International_Workshop_HM_2016_Plymouth_UK_June_8-10_2016_Proceedings"
              target="_blank"
            >
              View Publication
              </Link>
          </Typography>

          <Typography className={classes.repository}>Link 2</Typography>
          <Typography className={classes.url}>
            <Link
              component="a"
              href="http://link.springer.com/chapter/10.1007/978-3-319-39636-1_9"
              target="_blank"
            >
              View Publication
              </Link>
          </Typography>

        </Grid>
      </Grid>
      <hr style={{ borderColor: '#E8E8E8', borderTop: 'none', borderLeft: 'none', borderRight: 'none', paddingTop: '3vh' }} />
    </div>
  );
};


export default Header;